import { range } from 'mojito/utils';
import SkeletonPart from 'presentation/components/skeleton-part/index.js';
import FlexPane from 'presentation/components/flex-pane/index.js';

const FiltersBarSkeleton = props => {
    const {
        mojitoTools: { config },
    } = props;

    return (
        <FlexPane config={config.container} class="ta-FiltersBarSkeleton">
            {range(config.numberOfButtons).map(i => {
                return <SkeletonPart key={i} config={config.buttonSkeleton} />;
            })}
        </FlexPane>
    );
};

export default FiltersBarSkeleton;
